<div class="pe-se-title">
    Header
  </div>
  <mat-form-field class="pe-se-input">
    <mat-label>Background Color</mat-label>
    <input matInput
           [(ngModel)]="header.bgColor"
           [(colorPicker)]="header.bgColor"
           [style.background]="header.bgColor">
  </mat-form-field>
  <mat-form-field class="pe-se-input">
    <mat-label>Link Color</mat-label>
    <input matInput
           [(ngModel)]="header.colorLink"
           [(colorPicker)]="header.colorLink"
           [style.background]="header.colorLink">
  </mat-form-field>
  <div class="pe-se-input">
    <mat-label>Padding On Sides</mat-label>
    <mat-slider class="pe-se-slider"
                [(ngModel)]="header.paddingOnSides"
                thumbLabel
                tickInterval="1"
                min="10"
                max="300"></mat-slider>
  </div>
  <div class='pe-se-input pe-se-file'>
    <input type='file' (change)="selectFile($event)"  accept="image/*">
    <img alt="logo" [attr.src]="header.logo" />
  </div>
